import React from "react";
import "./CookiePolicy"; // reuse the same CSS styling

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Terms and Conditions</h1>
      <p>
        Welcome to <strong>Treasure Funded</strong>. By accessing and using our
        website, services, or programs, you agree to comply with and be bound by
        the following Terms and Conditions. Please read them carefully before
        using our platform.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        By registering or participating in our services, you confirm that you
        are at least 18 years old and legally eligible to enter into binding
        agreements under applicable law.
      </p>

      <h2>2. Use of Services</h2>
      <p>
        You agree to use our services solely for lawful purposes and in
        accordance with these Terms. Unauthorized use of our platform,
        including but not limited to fraudulent activities, hacking attempts, or
        sharing of account credentials, is strictly prohibited.
      </p>

      <h2>3. Accounts and Security</h2>
      <p>
        You are responsible for maintaining the confidentiality of your login
        credentials. Treasure Funded is not liable for losses resulting from
        unauthorized use of your account due to negligence in safeguarding
        credentials.
      </p>

      <h2>4. Trading Disclaimer</h2>
      <p>
        Participation in simulated trading challenges or funded accounts does
        not guarantee profits in real-world markets. All trading involves risk,
        and you are solely responsible for your decisions.
      </p>

      <h2>5. Fees and Payments</h2>
      <p>
        Any fees paid for accessing our challenges, services, or subscriptions
        are non-refundable unless otherwise stated. By making a payment, you
        agree to our pricing and billing policies.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        All content, logos, trademarks, and materials available on the Treasure
        Funded platform are the intellectual property of Treasure Funded and may
        not be copied, distributed, or reproduced without prior written
        permission.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        Treasure Funded shall not be held responsible for any financial losses,
        damages, or claims arising from the use of our services. All activities
        are undertaken at your own risk.
      </p>

      <h2>8. Termination</h2>
      <p>
        We reserve the right to suspend or terminate any account that violates
        our Terms, engages in fraudulent activity, or compromises the integrity
        of our platform.
      </p>

      <h2>9. Amendments</h2>
      <p>
        Treasure Funded reserves the right to update or modify these Terms and
        Conditions at any time. Continued use of the platform after changes
        indicates acceptance of the revised terms.
      </p>

      <h2>10. Governing Law</h2>
      <p>
        These Terms and Conditions shall be governed by and construed in
        accordance with the laws of the United Kingdom, without regard to its
        conflict of law principles.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions regarding these Terms and Conditions, please
        contact us at:
        <br />
        📧 <a href="mailto:support@treassurefunded.com">support@treassurefunded.com</a>
      </p>
    </div>
  );
};

export default TermsAndConditions;


